import { get } from "lodash";
import { CooSubmission, SubmitFinancing, SubmitConveyancing, SubmitConveyancingTenancyInCommon, SubmitConveyancingLegalRepresentation, SubmitDocuments } from "./CooSubmission.class";
import { StageBConveyancing, StageBPersonalDetail } from "./stage-b/review-endorse.class";
import { HoldingTypeEnum } from "../enum/holding-type.enum";
import { Owner } from "../polymer/Owner.model";
import { StructureStatusEnum } from "../enum/structure-status.enum";
import { OwnerTypeEnum } from "../enum/owner-type.enum";
import { FileItem } from "../polymer/Document.model";
import { ApplicationStep1 } from "./ApplicationStep1.class";
import { HoldingFormData } from "../polymer/HoldingFormData.model";
import { IDTypeEnum } from "../enum/id-type.enum";
import { PolymerCrypto } from "../../utils/encryptor";

export class CooGiveConsent extends CooSubmission{

  application_uuid?: string
  give_consent: boolean
  owner: GiveConsentOwner
  financing_info: SubmitFinancing;
  conveyancing: SubmitConveyancing;

  constructor(initial?:any){
    super(initial);

    this.application_uuid = get(initial, "application_uuid", undefined);
    this.give_consent = get(initial, "give_consent", false);
    this.owner = get(initial, "owner", new GiveConsentOwner());
    this.financing_info = get(initial, "financing_info", new SubmitFinancing());
    this.conveyancing = get(initial, "conveyancing", new SubmitConveyancing());
  }
  
  setOwner(initial:StageBPersonalDetail){
    this.owner = new GiveConsentOwner({
      relationship_with_owner : initial.login_user.relationship_with_owner,
      uinfin                  : PolymerCrypto.encryption(initial.login_user.myinfo.uinfin),
      mobile_no               : PolymerCrypto.encryption(initial.login_user.myinfo.mobile_no),
      marital_status          : initial.login_user.myinfo.marital_status,
      email                   : PolymerCrypto.encryption(initial.login_user.myinfo.email),
      sex                     : initial.login_user.myinfo.sex || null,
      race                    : initial.login_user.myinfo.race || null,
      nationality             : initial.login_user.myinfo.nationality || null,
      spouse                  : PolymerCrypto.encryption(initial.login_user.spouse) || "",
      spouse_id_type          : initial.login_user.spouse_id_type || undefined,
      gross_monthly_income    : initial.login_user.gross_monthly_income || undefined
    });
  }


  setHoldingValuesToOwnerObj(initial: HoldingFormData){

    let holdingValueApplicant = new Owner();
    if(initial.holding_owners.length > 0){
      holdingValueApplicant = new Owner({...initial.holding_owners[0]});
    }
    else if (initial.holding_occupiers.length > 0){
      holdingValueApplicant = new Owner({...initial.holding_owners[0]});
    }

    this.owner = new GiveConsentOwner({
      relationship_with_owner : holdingValueApplicant.relationship_with_owner,
      uinfin                  : PolymerCrypto.encryption(holdingValueApplicant.myinfo.uinfin),
      mobile_no               : PolymerCrypto.encryption(holdingValueApplicant.myinfo.mobile_no),
      marital_status          : holdingValueApplicant.myinfo.marital_status,
      email                   : PolymerCrypto.encryption(holdingValueApplicant.myinfo.email),
      sex                     : holdingValueApplicant.myinfo.sex || null,
      race                    : holdingValueApplicant.myinfo.race || null,
      nationality             : holdingValueApplicant.myinfo.nationality || null,
      spouse                  : PolymerCrypto.encryption(holdingValueApplicant.spouse) || "",
      spouse_id_type          : holdingValueApplicant.spouse_id_type || undefined,
      gross_monthly_income    : holdingValueApplicant.gross_monthly_income || undefined
    });
  }

  setGiveConsent(initial: boolean){
    this.give_consent = true;
  }
  setApplicationId(initial: string){
    this.application_uuid = initial;
  }

  setFinancingInfo(initial: SubmitFinancing) {
     this.financing_info = initial;
  }

  setConveyancing(initial: StageBConveyancing){
    let process_tenancy_in_common:SubmitConveyancingTenancyInCommon[] = [];

    if(initial.holding_type === HoldingTypeEnum.tenancy_in_common ){
      process_tenancy_in_common = initial.tenancy_in_common.map(e=>{
        return new SubmitConveyancingTenancyInCommon({owner_uinfin:e.user.myinfo.uinfin, share_percent: e?.shares ? Number(e?.shares) : 0})
      })
    }

    //Process legal_representation
    let current_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    current_legal_representation.generateCurrentSubmissionJson(initial);
    
    let proposed_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    proposed_legal_representation.generateProposedSubmissionJson(initial);
    
  
    
    this.conveyancing.holding_type = initial.holding_type?.toString() ?? "";
    this.conveyancing.valuation = initial.valuation;
    this.conveyancing.estimated_market_value = initial.estimated_market_value;
    this.conveyancing.tenancy_in_common = process_tenancy_in_common;
    this.conveyancing.legal_representation = [current_legal_representation,proposed_legal_representation];
  }

  setConveyancingStageB(initial: StageBConveyancing, mainApplicantStructureStatus?: StructureStatusEnum){

    let process_tenancy_in_common:SubmitConveyancingTenancyInCommon[] = [];

    //Process legal_representation
       
    let proposed_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    proposed_legal_representation.generateProposedSubmissionJson(initial);
    
    let current_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    current_legal_representation.generateCurrentSubmissionJson(initial);

    let outgoing_legal_representation: SubmitConveyancingLegalRepresentation = new SubmitConveyancingLegalRepresentation();
    outgoing_legal_representation.generateOutgoingSubmissionJson(initial);

    if(initial.holding_type === HoldingTypeEnum.tenancy_in_common ){
      process_tenancy_in_common = initial.tenancy_in_common.map(e=>{
        return new SubmitConveyancingTenancyInCommon({owner_uinfin:e.user.myinfo.uinfin, share_percent: e?.shares ? Number(e?.shares) : 0})
      })
    }

    //When login user is outgoing owner is represented by a different solicictor is "uncheck"
    if(mainApplicantStructureStatus === StructureStatusEnum.outgoing && initial.proposed_same_solicitor){
      proposed_legal_representation.generateCurrentSubmissionJson(initial, OwnerTypeEnum.proposed);
    }
  
    
    this.conveyancing.holding_type = initial.holding_type?.toString() ?? "";
    this.conveyancing.valuation = initial.valuation;
    this.conveyancing.estimated_market_value = initial.estimated_market_value;
    this.conveyancing.tenancy_in_common = process_tenancy_in_common;
   
    const legalRepresentations = [current_legal_representation,proposed_legal_representation];
    if(initial.outgoing_different_solicitor){
       legalRepresentations.push(outgoing_legal_representation);
    }
    this.conveyancing.legal_representation = legalRepresentations;
  }

  setStageBDocuments(file_items:FileItem[]){
    this.documents = file_items.map(file=>{
      let fileType = "";
      if(file?.file_content?.file_name){
        const fileNameSplitArray = file?.file_content?.file_name.split('.');
        fileType = fileNameSplitArray[fileNameSplitArray.length - 1];
      }
      return new SubmitDocuments({uuid:file.file_id.toString(), code: file.code, file_name:file.file_content?.file_name ,label: file.label,document_type: fileType, required_option_checked:true});
    });
  }


  setMapRelationshipWithOwner(applicationStep1FormData:ApplicationStep1, loginUserUinfin:string){
    // if is new incoming owner/occupier, get relationship with owner and send to consent

    //NOTE : why HSS3 is because only HSS3 will have relationship with owner, and selecting existing current owner will not ask for that.
    const incoming_owners = applicationStep1FormData.household.incoming_owners.filter(e=>e.structure_status === StructureStatusEnum.incoming).find(e=> e.myinfo.uinfin === loginUserUinfin);
    if(incoming_owners){
      this.owner = new GiveConsentOwner({...this.owner, relationship_with_owner: incoming_owners.relationship_with_owner});
    }
    
    // if(applicationStep1FormData.household.incoming_owners.filter((item) => item.myinfo.uinfin === loginUser.uinfin).length > 0){
    //   // consentObj.owner.relationship_with_owner = applicationStep1FormData.household.incoming_owners.filter((item) => item.myinfo.uinfin === loginUser.uinfin)[0].relationship_with_owner;
    // } else if(applicationStep1FormData.household.incoming_occupiers.filter((item) => item.myinfo.uinfin === loginUser.uinfin)) {
    //   // consentObj.owner.relationship_with_owner = applicationStep1FormData.household.incoming_occupiers.filter((item) => item.myinfo.uinfin === loginUser.uinfin)[0].relationship_with_owner;
    // }

  }
  
  getGiveConsentJSON(){
    const {flat_type, holding_type, hdb_ref, address, change_ownership_reason, has_private_property, has_dispose_property, change_in_marital_status, change_in_financial_circumstances, demise_of_current_owner, renunciation, moving_out, owners, occupiers, confirm_attend_completion_person, main_applicant_uinfin, ...rest} = {...this};
    return rest;
  }
  
}
  
  
  
class GiveConsentOwner {
  relationship_with_owner  : string;
  uinfin                   : string;
  mobile_no                : string;
  marital_status           : string;
  email                    : string;
  sex                      : string | null;
  race                     : string | null; 
  nationality              : string | null;
  spouse                   : string;
  spouse_id_type           : IDTypeEnum | undefined;
  gross_monthly_income     : string | undefined;
    
  constructor(initial?: GiveConsentOwner){
    this.relationship_with_owner = get(initial, "relationship_with_owner", "");
    this.uinfin                  = get(initial, "uinfin", "");
    this.mobile_no               = get(initial, "mobile_no", "");
    this.marital_status          = get(initial, "marital_status", "");
    this.email                   = get(initial, "email", "");
    this.sex                     = get(initial, "sex", null);
    this.race                    = get(initial, "race", null);
    this.nationality             = get(initial, "nationality", null);
    this.spouse                  = get(initial, "spouse", "");
    this.spouse_id_type          = get(initial, "spouse_id_type", undefined);
    this.gross_monthly_income    = get(initial, 'gross_monthly_income',  undefined);
  }
}